import {
    Component,
    Inject,
    Input,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { fuseAnimations } from "@fuse/animations";
import { CotizacionesService } from "app/main/apps/shared/services/rest/cotizaciones.service";

@Component({
    selector: "app-dialog-adjunto",
    templateUrl: "./dialog-adjunto.component.html",
    styleUrls: ["./dialog-adjunto.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogAdjuntoComponent implements OnInit {
    archivo: SafeResourceUrl;
    constructor(
        public dialogRef: MatDialogRef<DialogAdjuntoComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { idServicioSolicitud: number },
        private _cotizacionesSrvc: CotizacionesService,
        private _sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.verAdjunto();
    }

    verAdjunto() {
        this._cotizacionesSrvc
            .fetchArchivoCotizacion(this.data.idServicioSolicitud)
            .subscribe((blob) => {
                //console.log(blob);
                let objectURL = URL.createObjectURL(blob);
                this.archivo = this._sanitizer.bypassSecurityTrustResourceUrl(
                    objectURL
                );
            });
    }
}
